import createReactComponent from '../createReactComponent';
var SkipForward = createReactComponent('SkipForward', [['polygon', {
  points: '5 4 15 12 5 20 5 4',
  key: '16p6eg'
}], ['line', {
  x1: '19',
  y1: '5',
  x2: '19',
  y2: '19',
  key: '5lndli'
}]]);
export default SkipForward;